import { Injectable } from '@nestjs/common';
import { AssetsClassificationAdapter } from './assets-classification-adpater';
import { AssetsClassificationDTO } from './dto/assets-classification-dto';
import { AssetsCode, ErrorResponse } from '@gtpl/shared-models/common-models';
import { AssetsClassificationRepository } from './dto/assets-classification-repository';
import { Raw } from 'typeorm';
import { AssetsClassification } from './assets-classification-entity';
import { AllAssetsResponse, AssetResponseModel, AssetsClasificationDropDownDto, AssetsClassificationDropDownResponse, AssetsClassificationResponseModel, AssetsDto, AssetsResponse } from '@gtpl/shared-models/asset-management'
import { assetsClassificationDtoActive } from './dto/assets-classification-active-deactive';


@Injectable()
export class AssetsClassificationService {
    constructor(private repository: AssetsClassificationRepository, private adapter: AssetsClassificationAdapter) {

    }

    async CreateAssetsClassification(details: AssetsClassificationDTO, isUpdate: boolean = false): Promise<AssetsClassificationResponseModel> {
        try {
            if (!isUpdate) {
                const assetsEntity = await this.getAssetsClassification(details.assetsClassificationName, details.assetCodeRequired, details.assetsClassificationCode);
                if (assetsEntity) {
                    throw new ErrorResponse(11104, 'AssetsClassification  already exists');
                }
            } else {
                const assetsEntity = await this.getAssetsClassificationForUpdate(details.assetsClassificationName, details.assetsClassificationCode, details.assetsClassificationId);
                console.log(assetsEntity);
                if (assetsEntity) {
                    if (assetsEntity.assetsClassificationId != details.assetsClassificationId) {
                        throw new ErrorResponse(11104, 'AssetsClassification already exists');
                    }
                }
            }
            const convertedEntity = await this.adapter.convertDtoToEntity(details);
            const response = await this.repository.save(convertedEntity);
            if (response) {
                const data = new AssetsDto(response.assetsClassificationName, response.assetsClassificationCode, response.createdUser, response.isActive, response.updatedUser, response.assetsClassificationId, response.versionFlag, response.assetCodeRequired);
                return new AssetsClassificationResponseModel(true, 2234, 'AssetsClassification Details Created Successfully', data)
            } else {
                throw new ErrorResponse(9999, 'Failed To Create');
            }
        }
        catch (error) {
            return error;
        }
    }
    async getAllAssetsClassification(): Promise<AllAssetsResponse> {
        const responseDate = await this.repository.find({ order: { assetsClassificationCode: "ASC" } });

        const assetsDetails: AssetsDto[] = [];
        if (responseDate.length > 0) {
            responseDate.forEach((assets) => {
                const assetsData = new AssetsDto(assets.assetsClassificationName, assets.assetsClassificationCode, assets.createdUser, assets.isActive, assets.updatedUser, assets.assetsClassificationId, assets.versionFlag, assets.assetCodeRequired);
                assetsDetails.push(assetsData);
            })
            return new AllAssetsResponse(true, 2234, 'assets Details Retrived Successfully', assetsDetails)
        } else {
            throw new ErrorResponse(9999, 'No Data Found');
        }

    }

    async getRecordByAssetsClassificationId(id: number): Promise<AssetResponseModel> {
        const responseData = await this.repository.findOne({ where: { assetsClassificationId: id } });

        if (responseData) {
            const data = new AssetsDto(responseData.assetsClassificationName, responseData.assetsClassificationCode, responseData.createdUser, responseData.isActive, responseData.updatedUser, responseData.assetsClassificationId, responseData.versionFlag, responseData.assetCodeRequired);
            return new AssetResponseModel(true, 7879, 'Data Retrived Successfully', data);
        } else {
            throw new ErrorResponse(9999, 'No Data Found');
        }
    }


    async getAssetsClassification(assetsClassificationName: string, assetCodeRequired: AssetsCode, assetsClassificationCode: string) {
        const response = await this.repository.findOne({
            where: { assetsClassificationName: Raw(alias => `assets_classification_name = '${assetsClassificationName}'`), assetsClassificationCode: Raw(alias => `assets_classification_code = '${assetsClassificationCode}'`), assetCodeRequired: Raw(alias => `asset_code_required = '${assetCodeRequired}'`) }

        });

        if (response) {
            return response;
        } else {
            return null;
        }
    }

    async getAssetsClassificationForUpdate(assetsClassificationName: String, assetsClassificationCode: string, id: number): Promise<AssetsClassification> {
        const responseCode = await this.repository.findOne({
            where: { assetsClassificationCode: assetsClassificationCode },
        });
        const responseNo = await this.repository.findOne({
            where: { assetsClassificationName: assetsClassificationName },
        });
        if (responseCode || responseNo) {
            if (responseCode && responseNo) {
                if (responseCode.assetsClassificationId == responseNo.assetsClassificationId) {
                    return responseCode;
                }
                else if (responseCode.assetsClassificationId == id) {
                    return responseNo;
                }
                else if (responseNo.assetsClassificationId == id) {
                    return responseCode;
                }
                else {
                    return responseCode;
                }
            }
            else if (responseCode && !responseNo) {
                return responseCode;
            }
            else if (responseNo && !responseCode) {
                return responseNo;
            }
        } else {
            return null;
        }
    }

    async getAssetsData(assetsClassificationId: number): Promise<AssetsClassification> {
        //  console.log(employeeId);
        const response = await this.repository.findOne({
            where: { assetsClassificationId: assetsClassificationId },
        });

        if (response) {
            return response;
        } else {
            return null;


        }
    }

    async getAllAssetsClassificationDropDown(): Promise<AssetsClassificationDropDownResponse> {
        try {
            const zoneDTO: AssetsClasificationDropDownDto[] = [];
            const assetsEntities: AssetsClassification[] = await this.repository.find({ select: ['assetsClassificationId', 'assetsClassificationName'], where: { isActive: true }, order: { assetsClassificationName: "ASC" } })


            if (assetsEntities && assetsEntities.length > 0) {
                assetsEntities.forEach(assetsEntity => {
                    zoneDTO.push(new AssetsClasificationDropDownDto(assetsEntity.assetsClassificationId, assetsEntity.assetsClassificationName));
                });
                const response = new AssetsClassificationDropDownResponse(true, 11108, "assetsClassification retrieved successfully", zoneDTO);
                return response;
            } else {
                throw new ErrorResponse(99998, 'Data not found');
            }
        } catch (err) {
            throw err;
        }
    }

    async activateorDeactivateAssets(AssetsAct: assetsClassificationDtoActive): Promise<AssetsResponse> {
        try {
            const assetsExists = await this.getAssetsData(AssetsAct.assetsClassificationId);
            if (assetsExists) {
                if (AssetsAct.versionFlag !== assetsExists.versionFlag) {
                    throw new ErrorResponse(10113, 'Someone updated the current AssetsClassification information.Refresh and try again');
                } else {

                    const assetsSatatus = await this.repository.update(
                        { assetsClassificationId: AssetsAct.assetsClassificationId },
                        { isActive: AssetsAct.isActive, updatedUser: AssetsAct.updatedUser });
                    const updatedRecord = await this.getRecordByAssetsClassificationId(AssetsAct.assetsClassificationId);
                    if (assetsExists.isActive) {
                        if (assetsSatatus.affected) {
                            const assetsResponse: AssetsResponse = new AssetsResponse(true, 10115, 'AssetsClassification is de-activated successfully');
                            return assetsResponse;
                        } else {
                            throw new ErrorResponse(10111, 'AssetsClassification is already deactivated');
                        }
                    } else {
                        if (assetsSatatus.affected) {
                            const assetcatResponse: AssetsResponse = new AssetsResponse(true, 10114, 'AssetsClassification is activated successfully', updatedRecord.data);
                            return assetcatResponse;
                        } else {
                            throw new ErrorResponse(10112, 'assetsClassification is already  activated');
                        }
                    }
                }
            } else {
                throw new ErrorResponse(99998, 'No Records Found');
            }
        } catch (err) {
            throw err;
        }
    }
}




